var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.16,
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4FB050"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2927 6.85344C19.6833 7.24396 19.6833 7.87713 19.2927 8.26765L10.4141 17.1463C10.0235 17.5369 9.39037 17.5369 8.99985 17.1463L4.70696 12.8534C4.31643 12.4629 4.31643 11.8298 4.70696 11.4392C5.09748 11.0487 5.73065 11.0487 6.12117 11.4392L9.70696 15.025L17.8785 6.85344C18.2691 6.46292 18.9022 6.46292 19.2927 6.85344Z",
    fill: "#4FB050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.7a3c0d6ccac01cf3a9bcd4a3706ef67f.svg";
export { ForwardRef as ReactComponent };